export function commonFunc() {
	handleSamePageAnchorLinks();
	handleCrossPagesAnchorLinks();
  catalogFunc();
}

/**
 * アンカーリンク（同一ページ内）
 */
function handleSamePageAnchorLinks() {
	const header = document.querySelector('.l-header');
	const headerHeight = header ? header.offsetHeight : 0;

	function handleAnchorClick(event) {
		const target = event.target.closest('a[href*="#"]');
		if (target) {
			const href = target.getAttribute('href');
			const anchorIndex = href.indexOf('#');

			if (anchorIndex !== -1) {
				const targetUrlWithoutHash = href.slice(0, anchorIndex);
				const currentUrlWithoutHash = window.location.pathname + window.location.search;

				const isSamePageLink = (targetUrlWithoutHash === '' || targetUrlWithoutHash === currentUrlWithoutHash);

				if (isSamePageLink) {
					event.preventDefault();
					const targetId = href.slice(anchorIndex + 1);
					const targetElement = document.getElementById(targetId);
					if (targetElement) {
						const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
						window.scrollTo({
							top: targetPosition - headerHeight,
							behavior: 'smooth'
						});
					}
				}
			}
		}
	}

	document.addEventListener('click', handleAnchorClick);
}

/**
 * アンカーリンク（ページ遷移）
 */
function handleCrossPagesAnchorLinks() {
	const header = document.querySelector('.l-header');
	const headerHeight = header ? header.offsetHeight : 0;

	if (window.location.hash) {
		const targetId = window.location.hash.slice(1);
		const targetElement = document.getElementById(targetId);
		if (targetElement) {
			const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
			window.scrollTo({
				top: targetPosition - headerHeight,
				behavior: 'smooth'
			});
		}
	}
}

/**
 * カタログ
 */
function catalogFunc() {
  
  $('.js-tab-item').on('click', function(){
    // パンくず書き換え
    const $catName = $(this).data('cat-name');
    $('.js-catalog-cat').text($catName);

    //タブ切り替え
    const index = $('.js-tab-item').index(this);
    $('.l-archive-content, .js-tab-item').removeClass('is-active');
    $(this).addClass('is-active');
    $('.l-archive-content').eq(index).addClass('is-active');
  });
}